import { CardActions, Chip, styled } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'
import PublishDate from 'features/common/ui/Cards/PublishDate'
import CardOwnerAvatar from 'features/common/ui/Cards/CardOwnerAvatar'
import TagsCardFooter from 'features/tags/ui/TagsCardFooter'
import { FormattedMessage } from 'react-intl'

interface MapCardFooterProps {
  ownerPicture?: string
  ownerEmail?: string
  ownerIsCartoUser?: boolean
  updatedAt?: string
  tags?: string[]
  isDemo?: boolean
}

const CustomPaddingCardActions = styled(CardActions)(({ theme }) => ({
  padding: theme.spacing(0, 1.5, 1.5)
}))

function MapCardFooter({ ownerPicture, ownerEmail, ownerIsCartoUser, updatedAt, tags, isDemo }: MapCardFooterProps) {
  return (
    <CustomPaddingCardActions>
      <PublishDate
        date={updatedAt}
        ownerAvatar={
          ownerPicture ? (
            <CardOwnerAvatar picture={ownerPicture} email={ownerEmail} cartoUser={ownerIsCartoUser} />
          ) : undefined
        }
      />
      {isDemo && (
        <Chip
          label={
            <Typography component="p" variant="caption" noWrap>
              <FormattedMessage id="maps.cards.demo.tag" />
            </Typography>
          }
          size="small"
          variant="outlined"
          color="default"
        />
      )}
      <TagsCardFooter tags={tags} />
    </CustomPaddingCardActions>
  )
}

export default MapCardFooter
